import { Icon, type IconProps } from "./icon";

/** Settings: two set controls. */
export function SettingsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M3 6h2.6M9.4 6H17M3 14h7.6M14.4 14H17" />
      <circle cx="7.5" cy="6" r="1.9" />
      <circle cx="12.5" cy="14" r="1.9" />
    </Icon>
  );
}
